import React, { useMemo, useCallback } from 'react';
import ReactECharts from './Chart';

const colorPalette = ['#da291c', '#3cb17e', '#307fe2', '#9063cd', '#2cccd3', '#a2b2c8'];

const UserGraph = ({ data, onDateClick, startDate, endDate }) => {

  const onChartClick = useCallback((params) => {
    if (params.componentType === 'series') {
      let clickedDate = null;

      if (params.seriesName === 'clickArea') {
        clickedDate = params.name;
      } else if (params.seriesName === 'New Users' || params.seriesName === 'Total Users') {
        clickedDate = params.name;
      }

      if (clickedDate) {
        setTimeout(() => {
          onDateClick({ value: clickedDate, componentType: params.seriesName });
        }, 0);
      }
    }
  }, [onDateClick]);

  const option = useMemo(() => {
    if (!data || !data.userday || !data.usernew || !data.usernum) {
      return null;
    }

    const dates = data.userday;
    const newUsers = data.usernew;
    const totalUsers = data.usernum;

    // Calculate the interval for x-axis labels
    const interval = dates.length > 30 ? Math.floor(dates.length / 15) : 0;

    // Create clickable area data that extends to the top
    const clickAreaData = dates.map((date, index) => [index, 0]);

    return {
      color: colorPalette,
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        data: ['New Users', 'Total Users'],
        top: 0
      },
      xAxis: [
        {
          type: 'category',
          data: dates,
          axisLabel: {
            rotate: 45,
            interval: interval,
            fontSize: 10,
            formatter: (value, index) => {
              return interval === 0 || index % interval === 0 ? value : '';
            }
          },
          boundaryGap: false
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Number of Users',
          min: 0,
          axisLabel: {
            formatter: '{value}',
            fontSize: 10
          }
        }
      ],
      series: [
        {
          name: 'clickArea',
          type: 'custom',
          renderItem: (params, api) => {
            const location = api.coord([api.value(0), 0]);
            return {
              type: 'rect',
              shape: {
                x: location[0] - api.size([1, 0])[0] / 2,
                y: params.coordSys.y,
                width: api.size([1, 0])[0],
                height: params.coordSys.height
              },
              style: {
                fill: 'rgba(0, 0, 0, 0.01)'
              },
              emphasis: {
                style: {
                  fill: 'rgba(0, 0, 0, 0.1)'
                }
              }
            };
          },
          data: clickAreaData,
          z: 4,
          tooltip: {
            show: false
          },
          // Ensure the series is clickable
          silent: false
        },
        {
          name: 'New Users',
          type: 'bar',
          data: newUsers,
          itemStyle: {
            color: colorPalette[0]
          },
          barWidth: '50%',
          z: 2,
          offset: '-25%',
          // Make bars clickable as backup
          silent: false
        },
        {
          name: 'Total Users',
          type: 'line',
          yAxisIndex: 0,
          data: totalUsers,
          itemStyle: {
            color: colorPalette[1]
          },
          z: 3,
          // Make line clickable as backup
          silent: false
        }
      ],
      grid: {
        left: '5%',
        right: '5%',
        bottom: '20%',
        top: '10%',
        containLabel: true
      }
    };
  }, [data]);

  if (!option) {
    return <div>Error: Invalid data structure for UserGraph. Received: {JSON.stringify(data)}</div>;
  }

  return (
    <div style={{ height: '280px', width: '100%' }}>
      <ReactECharts
        option={option}
        style={{ height: '100%', width: '100%' }}
        onEvents={{ click: onChartClick }}
        key={`${startDate}-${endDate}-${data?.userday?.length || 0}`}
      />
    </div>
  );
};

export default UserGraph;